import { Helmet } from "react-helmet-async";

import Wrapper from "../elements/Wrapper"
import Content from "../elements/Content"

import { routesArray, homepage } from '../constants'

const ToolsList = () => {
    return (
        <Wrapper>
            <Helmet>
                <title>DEV-ToolsList | Templateroller</title>
            </Helmet>

            <h1>DEV-ToolsList</h1>

            <Content>
                <ul style={{
                    "width": "100%",
                    "background": "#fff",
                    "padding": "15px 50px",
                    "borderRadius": "8px",
                    "boxShadow": "rgb(0 0 0 / 15%) 0px 8px 16px",
                }}>
                    {
                        routesArray.map((path: string) => <li key={path} style={{
                            'padding': '4px 0',
                            'fontSize': '20px',
                        }}>
                            <a href={homepage + path} style={{
                                "textDecoration": "none",
                            }}>{path}</a>
                        </li>)
                    }
                </ul>
            </Content>
        </Wrapper>
    )
}

export default ToolsList